import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function usePayrollsList() {
  // Use toast
  const toast = useToast()

  const refPayrollListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'pay_period', label: 'Period', sortable: true },
    { key: 'pay_batch', label: 'Batch', sortable: true },
    // { key: 'id', label: '#', sortable: true },
    // { key: 'payrollStatus', label: 'Batch', sortable: true },
    { key: 'client', sortable: true },
    {
      key: 'total_earnings', label: 'earnings', sortable: true,
    },
    { key: 'total_deductions', label: 'deductions', sortable: true },
    { key: 'net_pay', label: 'netPay', sortable: true },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalPayrolls = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('xxxxx')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refPayrollListTable.value ? refPayrollListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalPayrolls.value,
    }
  })

  const refetchData = () => {
    refPayrollListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    refetchData()
  })

  const fetchPayrolls = (ctx, callback) => {
    store
      .dispatch('app-payroll/fetchPayrolls', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { payrolls, total } = response.data

        callback(payrolls)
        totalPayrolls.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching payrolls' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolvePayrollStatusVariantAndIcon = status => {
    if (status === 'Partial Payment') return { variant: 'warning', icon: 'PieChartIcon' }
    if (status === 'Paid') return { variant: 'success', icon: 'CheckCircleIcon' }
    if (status === 'Downloaded') return { variant: 'info', icon: 'ArrowDownCircleIcon' }
    if (status === 'Draft') return { variant: 'primary', icon: 'SaveIcon' }
    if (status === 'Sent') return { variant: 'secondary', icon: 'SendIcon' }
    if (status === 'Past Due') return { variant: 'danger', icon: 'InfoIcon' }
    return { variant: 'secondary', icon: 'XIcon' }
  }

  const resolveClientAvatarVariant = status => {
    if (status === 'Partial Payment') return 'primary'
    if (status === 'Paid') return 'danger'
    if (status === 'Downloaded') return 'secondary'
    if (status === 'Draft') return 'warning'
    if (status === 'Sent') return 'info'
    if (status === 'Past Due') return 'success'
    return 'primary'
  }

  return {
    fetchPayrolls,
    tableColumns,
    perPage,
    currentPage,
    totalPayrolls,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refPayrollListTable,

    statusFilter,

    resolvePayrollStatusVariantAndIcon,
    resolveClientAvatarVariant,

    refetchData,
  }
}
